// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "08498e31e297eae9","460": "0f8a4c8f7fbc2f86","917": "21e74828433a24c5","985": "e39cc43c99000d3b",}[chunkId] + ".chunk.js"
}